import { Popover } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EPTagContainer } from './styled';

const EPTag = ({ label, tooltipLabel, className }: { label?: string; tooltipLabel?: string; className?: string }) => {
  const { t } = useTranslation();

  return tooltipLabel ? (
    <Popover placement="top" content={t(tooltipLabel)}>
      <EPTagContainer className={className}>{t(label)}</EPTagContainer>
    </Popover>
  ) : (
    <EPTagContainer className={className}>{t(label)}</EPTagContainer>
  );
};

export const EPAlphaTag = props => <EPTag label="alpha" tooltipLabel="powerUsersOnly" {...props} />;
export const EPBetaTag = props => <EPTag label="beta" {...props} />;

export default EPTag;
